import { Columns } from '../interfaces/table/column-config';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { hasBalanceSupplierPartial } from '@shared/partials/has-balance-supplier.partial';
import { htxPartialTable } from '@shared/partials/htx-partial.table';
import { isChildPartial } from '@shared/partials/isChildPartial';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { meteringPointSubtypePartial } from '@shared/partials/meteringpointsubtype.partial';
import { MeteringPointQueryResultDto } from '@app/api/dmc';

export const isMeterActivePartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.isMeterActive',
  key: 'isMeterActive',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    0: { color: 'bg-red-500', label: 'common.no' },
    1: { color: 'bg-green-500', label: 'common.yes' },
  }
}

export const meteringPointIdPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.id',
  key: 'identification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/meteringpoint',
    urlReference: 'identification',
  }
}

export const addressPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.address',
  key: 'address',
  sortable: false,
  width: 250,
}

export const allowChangesPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.allowChanges',
  key: 'allowChanges',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    false: {color: 'bg-red-500', label: 'common.no'},
    true: {color: 'bg-green-500', label: 'common.yes'},
  }
}

export const existsInDataHubPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.existsInDataHub',
  key: 'existsInDataHub',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    false: {color: 'bg-red-500', label: 'common.no'},
    true: {color: 'bg-green-500', label: 'common.yes'},
  }
}

export const createdPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.created',
  key: 'created',
  cellRenderer: DateCellComponent,
}

export const idPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.id',
  key: 'id',
}

export const meteringPointIdentificationPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.identification',
  key: 'identification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/meteringpoint',
    urlReference: 'identification',
  }
}

export const meterNumberPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.meterNumber',
  key: 'meterNumber',
}

export const meterQuadrantPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.meterQuadrant',
  key: 'meterQuadrant',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meter.quadrantTypes.NotSpecified',
    consumption: 'meter.quadrantTypes.Consumption',
    production: 'meter.quadrantTypes.Production',
    reactivenegative: 'meter.quadrantTypes.ReactiveNegative',
    reactivepositive: 'meter.quadrantTypes.ReactivePositive'
  }
}

export const meterReadingOccurrencePartial: Columns<any> = {
  title: 'meteringpoint.table.meterReadingOccurrence',
  key: 'meterReadingOccurrence',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'Ikke angivet',
    year: 'År',
    month: 'Måned',
    day: 'Dag',
    hour: 'Time',
    quarter: 'Kvarter',
    other: 'Andet'
  }
}

export const meteringPointSubTypePartial: Columns<MeteringPointQueryResultDto> = meteringPointSubtypePartial

export const netSettlementGroupPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.netSettlementGroup',
  key: 'netSettlementGroup',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.netsettlementgroup.notspecified',
    "netsettlementgroup0": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup0',
    "netsettlementgroup1": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup1',
    "netsettlementgroup2": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup2',
    "netsettlementgroup3": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup3',
    "netsettlementgroup4": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup4',
    "netsettlementgroup5": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup5',
    "netsettlementgroup6": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup6',
    "netsettlementgroup99": 'enum.meteringpoint.netsettlementgroup.netsettlementgroup99',
  }
}

export const ownershipPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.ownership',
  key: 'ownership',
}

export const productCharacteristicIdentificationPartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.productCharacteristicIdentification',
  key: 'productCharacteristicIdentification',
}

export const productCharacteristicUnitTypePartial: Columns<MeteringPointQueryResultDto> = {
  title: 'meteringpoint.table.productCharacteristicUnitType',
  key: 'productCharacteristicUnitType',
}

export const MeteringPointColumns: Columns<MeteringPointQueryResultDto>[] = [
  addressPartial,
  allowChangesPartial,
  createdPartial,
  datahubPartial,
  existsInDataHubPartial,
  hasBalanceSupplierPartial,
  htxPartialTable,
  idPartial,
  isChildPartial,
  meterNumberPartial,
  meterQuadrantPartial,
  meterReadingOccurrencePartial,
  meteringPointIdentificationPartial,
  meteringPointSubTypePartial,
  meteringPointTypePartial,
  netSettlementGroupPartial,
  ownershipPartial,
  physicalStatusPartial,
  productCharacteristicIdentificationPartial,
  productCharacteristicUnitTypePartial,
  settlementmethodPartial,
  validFromPartialTable,
  validToPartialTable,
]
